import './table.sass';

export { default } from './table';
